export type WaitlistRequest = {
  email: string;
  native_languages: string[];
  target_languages: string[];
  country?: string;
  live_in?: string;
  country_name?: string;
  learning_goal?: string;
};

export type WaitlistResponse = { success: true } | { error: string };

export async function submitWaitlist(data: WaitlistRequest): Promise<WaitlistResponse> {
  const url = import.meta.env.VITE_WAITLIST_API_URL;

  if (!url) {
    return { error: "Waitlist service is not configured." };
  }

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      try {
        const body = await response.json();
        return { error: body.error ?? "Something went wrong. Please try again." };
      } catch {
        return { error: "Something went wrong. Please try again." };
      }
    }

    return { success: true };
  } catch {
    return {
      error: "Unable to reach the server. Please check your connection and try again.",
    };
  }
}
